import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {GetServerSideProps} from "next";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import Link from "next/link";
import {getSafeLocale} from "../helpers/LocalizeObject";
import Layout from "../components/common/Layout";
import {ReactElement} from "react";

export default function Impressum() {
	const {t} = useTranslation();

	return (
		<>
			<HeaderImageWithHeading 
				title=""
				imageSrc="/images/Impressum-header.jpg"
			/>
			<div className="container mx-auto mt-20 max-w-[1000px] my-10 px-6 md:px-20">
				<h3 className="mb-6 mt-8">{t("common.imprint")}</h3>
				<p>
					{t("consts.companyName")}
					<br/>
					{t("consts.address.line1")}
					<br/>
					{t("consts.address.line2")}
					<br/>
					{t("consts.address.line3")}
					<br/>
					{t("consts.address.line4")}
					<br/>
					<br/>
					{t("legal.managingDirector")}: 
					<br />
					{t("consts.managingDirector1")}
					<br />
					{t("consts.managingDirector2")}
				</p>
				<p>
					<br/>
					{t("common.phoneShort")}: {t("consts.contact.tel")}
					<br/>
					{t("common.fax")}: {t("consts.contact.fax")}
					<br/>
					{t("common.email")}: <a href={"mailto:" + t("consts.contact.email")}>{t("consts.contact.email")}</a>
					<br/>
					<br/>
					<Link href={t("consts.contact.website")!} target="_blank" rel="noopener noreferrer">
						{t("consts.contact.website")}
					</Link><br/>
				</p>
				<p className="mt-4">{t("pages.impressum.contactForMoreInfo")}</p>
				<p className="mt-4">
					{t("common.sales")}:<br/>
					<a href={"mailto:" + t("consts.contact.sales")}>{t("consts.contact.sales")}</a>
				</p>
				<p className="mt-4">
					{t("common.letting")}:<br/>
					<a href={"mailto:" + t("consts.contact.letting")}>{t("consts.contact.letting")}</a>
				</p>
				<p className="mt-4">
					{t("common.generalInformation")}:<br/>
					<a href={"mailto:" + t("consts.contact.info")}>{t("consts.contact.info")}</a>
				</p>
				<p className="mt-4">
					{t("common.lookingForwardToYourRequest")}
					<br/>
					{t("common.yourTeam")}
					<br/>
				</p>
				<p className="mt-4 whitespace-pre">
					<b>{t("legal.copyright")}</b><br/>
					©{t("pages.impressum.copyrights", {joinArrays: "\n©"})}
					<br/>
				</p>
			</div>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const sst = await serverSideTranslations(getSafeLocale(context.locale) as string, ["common"]);
	return {
		props: {
			...sst,
		},
	};
};

Impressum.getLayout = function getLayout(page: ReactElement) {
	return (
		<Layout 
			headerNotTransparent={false}
			hasShadow={true}
		>
			{page}
		</Layout>
	);
};